import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutTrust from './components/AboutTrust';
import FeatureGuide from './components/FeatureGuide';
import TestimonialsSection from './components/TestimonialsSection';
import { ArticleHub } from './components/ArticleHub';
import SEOArticles from './components/SEOArticles';
import FinalCTA from './components/FinalCTA';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://itaobuyspread.living';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'Itaobuy Spreadsheet Italia',
      url: siteUrl,
      description: 'Guida completa, tutorial, recensione, sicurezza e consigli per utilizzare Itaobuy Spreadsheet in modo intelligente.',
      inLanguage: 'it-IT',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/?s={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Itaobuy Spreadsheet Italia | Guida Completa, Recensione e Sicurezza 2026',
      description: 'Scopri Itaobuy Spreadsheet Italia: guida completa, tutorial, recensione, sicurezza, confronto prodotti e consigli per utilizzare Itaobuy in modo intelligente.',
      inLanguage: 'it-IT',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Itaobuy Spreadsheet Italia',
      url: siteUrl,
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Che cos\'è Itaobuy Spreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'È una guida organizzata che permette di analizzare prodotti e informazioni in modo più semplice.',
          },
        },
        {
          '@type': 'Question',
          name: 'Itaobuy Spreadsheet è gratuito?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Dipende dalle risorse e dagli strumenti utilizzati.',
          },
        },
        {
          '@type': 'Question',
          name: 'Come posso utilizzare Itaobuy Spreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Seguendo una procedura: ricerca → analisi → confronto → verifica → decisione.',
          },
        },
        {
          '@type': 'Question',
          name: 'Perché utilizzare una guida italiana?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Perché gli utenti italiani possono trovare spiegazioni più semplici e informazioni adattate alle loro esigenze.',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <AboutTrust />
        <FeatureGuide />
        <TestimonialsSection />
        <ArticleHub />
        <SEOArticles />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}